type ArErrorBannerProps = {
	message: string | null;
	onClose: () => void;
};

export const ArErrorBanner = ({ message, onClose }: ArErrorBannerProps): React.ReactElement | null => {
	if (!message) return null;

	return (
		<div
			style={{
				position: 'absolute',
				top: '16px',
				left: '16px',
				right: '16px',
				backgroundColor: '#FF3B30',
				color: 'white',
				padding: '12px 16px',
				borderRadius: '8px',
				fontSize: '14px',
				fontWeight: '500',
				zIndex: 200,
				boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
				fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between'
			}}
		>
			<span style={{ flex: 1 }}>{message}</span>
			<button
				onClick={onClose}
				style={{
					background: 'none',
					border: 'none',
					color: 'white',
					fontSize: '20px',
					fontWeight: 'bold',
					cursor: 'pointer',
					padding: '0',
					marginLeft: '12px',
					lineHeight: '1'
				}}
			>
				×
			</button>
		</div>
	);
};

